<button appPreventDoubleClick pButton pRipple class="p-button-outlined btnBlueColored" pTooltip="Deactivate" tooltipPosition="left" icon="fa fa-times" id="deactivateBtn" iconPos="left"
(debounceClick)="documentDeactivate()"></button>
<p-dialog [(visible)]="display" [style]="{width: '35vw'}" (onHide)="reloadDocumentDetail()" [modal]="true">
    <div *ngIf="errorMessages.length > 0">
        <p-messages severity="error">
          <ng-template pTemplate>
            <div>
            <span class="p-message-icon pi pi-times-circle"></span>
            <span class="p-ml-2">Please correct the following errors.</span>
            <br>
            <ul>
              <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
            </ul>
          </div>
          </ng-template>
        </p-messages>
      </div>
    <ng-template pTemplate="header">
       <b> Reason for Deactivating</b>
    </ng-template>
    <p>{{enterReasonMessage}}</p>
    <div class="col">
        <div class="field field-required">
            <bpt-text-input [ngClass]="{'error-highlight' : mandatoryFields.reason}" [highlightAllOnFocus]="true" 
            placeholder="Enter the Reason" [multiLine]="true" id="reasonForCancellationDescription" label="Reason*" 
            [(ngModel)]="reason" >
            </bpt-text-input>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button appPreventDoubleClick label="Confirm" type="submit" id="confirmButton"  (debounceClick)="confirmClick()" class="align-right" >
        </p-button>
        <p-button appPreventDoubleClick styleClass="p-button-outlined" label="Cancel" type="submit" id="cancelButton" (debounceClick)="cancelClick()" class="align-right" >
        </p-button>
    </ng-template>
</p-dialog>

